import { gql, TypedDocumentNode } from '@apollo/client';
import { ADDRESS_FRAGMENT } from '../fragments.rest';

export type DeleteAddressMutationVariables = {
  id: string;
};

export type DeleteAddressMutation = {
  deleteAddress: {
    data: null;
    __typename: 'RestDeleteAddress';
  };
};

export const DELETE_ADDRESS_MUTATION: TypedDocumentNode<
  DeleteAddressMutation,
  DeleteAddressMutationVariables
> = gql`
  mutation DeleteAdressMutation($id: String!) {
    deleteAddress(id: $id)
      @rest(
        type: "RestDeleteAddress"
        endpoint: "user"
        path: "/addresses/{args.id}"
        method: "DELETE"
      ) {
      data @type(name: "RestAddress") {
        ...AddressFragment
      }
    }
  }
  ${ADDRESS_FRAGMENT}
`;
